import { AnalyticsRoutes } from './type'

const analytics = `${AnalyticsRoutes.root}`
const analyticsOverall = `${analytics}/${AnalyticsRoutes.overall}`
const analyticsConversations = `${analytics}/${AnalyticsRoutes.conversations}`
const analyticsMessages = `${analytics}/${AnalyticsRoutes.messages}`
const analyticsCalls = `${analytics}/${AnalyticsRoutes.calls}`
const analyticsPerformance = `${analytics}/${AnalyticsRoutes.performance}`
const analyticsContacts = `${analytics}/${AnalyticsRoutes.contacts}`
const analyticsConversions = `${analytics}/${AnalyticsRoutes.conversions}`
const analyticsConversionsDetails = `${analytics}/${AnalyticsRoutes.conversions}/:id`
const analyticsCreditUsage = `${analytics}/${AnalyticsRoutes.creditUsage}`
const analyticsCreditUsageAll = `${analyticsCreditUsage}/${AnalyticsRoutes.all}`
const analyticsCreditUsageSources = `${analyticsCreditUsage}/${AnalyticsRoutes.sources}`

export const AnalyticsPath = {
  root: analytics,
  overall: analyticsOverall,
  conversations: analyticsConversations,
  messages: analyticsMessages,
  calls: analyticsCalls,
  performance: analyticsPerformance,
  contacts: analyticsContacts,
  conversions: analyticsConversions,
  conversionDetails: analyticsConversionsDetails,
  creditUsage: analyticsCreditUsage,
  creditUsageAll: analyticsCreditUsageAll,
  creditUsageSources: analyticsCreditUsageSources,
}
